module.exports = __webpack_public_path__ + "static/media/right-arrow.55d16e0e.svg";